import { Routes } from 'app/config/routes/consts';

export const SIDEBAR_LOCKED_ROUTES = [
	Routes.editFileRoot,
	Routes.editModelFileRoot,
	Routes.generativeModelFileEditor,
];
